import { graphql, useStaticQuery } from 'gatsby'
import React, { useState, useEffect } from 'react'
import useMobile from '../../../hooks/useMobile'
import ModalChangeCountry from '../modal-change-country/modal-change-country'
import { StaticImage, GatsbyImage } from 'gatsby-plugin-image'
import useHomeLinkMode from "../../../hooks/useHomeLinkMode";
import useHaveClubPeque from '../../../hooks/useHaveClubPeque'
import { sessionStorage } from '../../../utils/storage'
import './footer.scss'


//-------DELETE WHEN CMS--------

const Footer = props => {

    const resultQuery = useStaticQuery(
        graphql`
            query{
                allContentfulPequeninFooter {
                    nodes {
                        node_locale
                      tituloLegal
                      tituloTerminosYCondiciones
                      tituloPoliticasDeUso
                      tituloNecesitasAyuda
                      tituloLineaGratuita
                      tituloNumeroDeLinea
                      tituloNumeralCelular
                      tituloPreguntasFrecuentes
                      tituloRedesSociales
                      tituloContactanos
                      redireccionContactanos
                      redesSociales {
                        nombreDeLaCategoria
                        redireccionDeLaCategoria
                        imagenCategorias {
                            description
                            gatsbyImageData(formats: [AUTO, WEBP], placeholder: BLURRED)
                        }
                      }
                      redireccionTerminosYCondiciones
                      redireccionPreguntasFrecuentes
                      redireccionPoliticasDeUso
                      redireccionNumeroDeLinea
                      redireccionNumeralCelular
                      paises {
                        pais
                        dominioDelPais
                        banderaPais {
                          gatsbyImageData(formats: [AUTO, WEBP], placeholder: BLURRED)
                          description
                          file{
                              url
                          }
                        }                      
                      }
                      redireccionGrupoExito
                      tituloTerminosYCondicionesGrupoExito
                      redireccionPequeinSobreRuedas
                      tituloTrminosYCondicionesPequeninSobreRuedas
                      whatsapp
                      redireccionWhatsapp
                    }
                  }
            } 
        
        `
    )

    const menuOptions = resultQuery.allContentfulPequeninFooter.nodes.filter(e => e.node_locale === process.env.LOCALE)[0]
    const [modalChange, setModalChange] = useState(false)
    const [screen, setScreen] = useState("home");
    const mobile = useMobile();
    const { homeLink } = useHomeLinkMode();
    const {haveClubPeque} = useHaveClubPeque()

    const openModal = () => {
        if (mobile) {
            document.documentElement.style.overflow = 'hidden';
            document.body.scroll = "no";
        }
        setModalChange(true)
    }

    useEffect(() => {
        let isBrowser = typeof window !== 'undefined'
        let path = isBrowser ? window.location.pathname : '/'
        if (path) {
            let elements = path.split('/')
            elements.shift()
            if (elements[elements.length - 1] === '') elements.pop()
            if (elements && elements[elements.length - 1]) {
                setScreen(elements[elements.length - 1].replace(/\s+/g, '').replace(/-/g, ' '))
            }
        }
    }, []);


    return (
        <footer className="f-m-footer">
            <StaticImage
                className="f-m-footer-logo"
                src='../../../assets/images/logo-pequenin-desktop.png'
                alt='logo pequenin header'
                // loading="eager"
                placeholder="blurred"
            />
            <div className="f-m-footer__content">
                <div className="f-m-footer__content-item">
                    <h3>{menuOptions.tituloLegal}</h3>
                    <ul>
                        <li><a className="f-m-footer__content-item-redirection"
                            onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'trackEvent',
                                    'eventCategory': 'ui :: footer :: ' + screen,
                                    'eventAction': 'click',
                                    'eventLabel': menuOptions.tituloTerminosYCondiciones
                                });

                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'trackGA4',
                                    'event_type': 'user_interaction',
                                    'section': 'footer',
                                    'action': 'click',
                                    'element': menuOptions.tituloTerminosYCondiciones,
                                    'screen_name': screen
                                });
                            }}
                            href={homeLink + menuOptions.redireccionTerminosYCondiciones}
                        >{menuOptions.tituloTerminosYCondiciones}</a></li>
                        <li><a className="f-m-footer__content-item-redirection"
                            onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'trackEvent',
                                    'eventCategory': 'ui :: footer :: ' + screen,
                                    'eventAction': 'click',
                                    'eventLabel': menuOptions.tituloPoliticasDeUso
                                });

                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'trackGA4',
                                    'event_type': 'user_interaction',
                                    'section': 'footer',
                                    'action': 'click',
                                    'element': menuOptions.tituloPoliticasDeUso,
                                    'screen_name': screen
                                });
                            }}
                            href={homeLink + menuOptions.redireccionPoliticasDeUso}
                        >{menuOptions.tituloPoliticasDeUso}</a></li>
                        {(process.env.LOCALE === "es-CO" &&
                            haveClubPeque) ?
                            <li><a className="f-m-footer__content-item-redirection"
                                onClick={() => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackEvent',
                                        'eventCategory': 'ui :: footer :: ' + screen,
                                        'eventAction': 'click',
                                        'eventLabel': menuOptions.tituloTerminosYCondicionesGrupoExito
                                    });

                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackGA4',
                                        'event_type': 'user_interaction',
                                        'section': 'footer',
                                        'action': 'click',
                                        'element': menuOptions.tituloTerminosYCondicionesGrupoExito,
                                        'screen_name': screen
                                    });
                                }}
                                href={homeLink + menuOptions.redireccionGrupoExito}
                            >{menuOptions.tituloTerminosYCondicionesGrupoExito}</a></li>
                            :
                            (process.env.LOCALE === "es-EC") &&
                            haveClubPeque &&
                                <li><a className="f-m-footer__content-item-redirection"
                                onClick={() => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackEvent',
                                        'eventCategory': 'ui :: footer :: ' + screen,
                                        'eventAction': 'click',
                                        'eventLabel': menuOptions.tituloTrminosYCondicionesPequeninSobreRuedas
                                    });

                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackGA4',
                                        'event_type': 'user_interaction',
                                        'section': 'footer',
                                        'action': 'click',
                                        'element': menuOptions.tituloTrminosYCondicionesPequeninSobreRuedas,
                                        'screen_name': screen
                                    });
                                }}
                                href={homeLink + menuOptions.redireccionPequeinSobreRuedas}
                            >{menuOptions.tituloTrminosYCondicionesPequeninSobreRuedas}</a></li>
                        }
                    </ul>
                </div>
                <div className="f-m-footer__content-item">
                    <h3>{menuOptions.tituloNecesitasAyuda}</h3>
                    <ul>
                        {((process.env.LOCALE === "es-CO") || (process.env.LOCALE === "es-EC")) &&
                            <>
                                <li>{menuOptions.tituloLineaGratuita}</li>
                                <li><a className="f-m-footer__content-item-redirection"
                                    onClick={() => {
                                        window.dataLayer = window.dataLayer || [];
                                        window.dataLayer.push({
                                            'event': 'trackEvent',
                                            'eventCategory': 'ui :: footer :: ' + screen,
                                            'eventAction': 'click',
                                            'eventLabel': "linea gratuita"
                                        });

                                        window.dataLayer = window.dataLayer || [];
                                        window.dataLayer.push({
                                            'event': 'trackGA4',
                                            'event_type': 'user_interaction',
                                            'section': 'footer',
                                            'action': 'click',
                                            'element': "linea gratuita",
                                            'screen_name': screen
                                        });
                                    }}
                                    href={menuOptions.redireccionNumeroDeLinea} rel="nofollow">
                                    <span className="icon icon-ico-phone f-m-footer__content-item-icon"></span>{menuOptions.tituloNumeroDeLinea}</a></li>
                            </>
                        }
                        {(process.env.LOCALE === "es-CO") &&
                            <li><a className="f-m-footer__content-item-redirection"
                                onClick={() => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackEvent',
                                        'eventCategory': 'ui :: footer :: ' + screen,
                                        'eventAction': 'click',
                                        'eventLabel': "celular"
                                    });

                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackGA4',
                                        'event_type': 'user_interaction',
                                        'section': 'footer',
                                        'action': 'click',
                                        'element': "celular",
                                        'screen_name': screen
                                    });
                                }}
                                href={menuOptions.redireccionNumeralCelular} rel="nofollow">
                                <span className="icon icon-ico-cellphone f-m-footer__content-item-icon"></span>{menuOptions.tituloNumeralCelular}</a></li>
                        }
                        <li className="f-m-footer__li-no-underline"><a className="f-m-footer__content-item-redirection" href={homeLink + menuOptions.redireccionContactanos}
                            onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'trackEvent',
                                    'eventCategory': 'ui :: footer :: ' + screen,
                                    'eventAction': 'click',
                                    'eventLabel': menuOptions.tituloContactanos
                                });

                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'trackGA4',
                                    'event_type': 'user_interaction',
                                    'section': 'footer',
                                    'action': 'click',
                                    'element': menuOptions.tituloContactanos,
                                    'screen_name': screen
                                });
                                sessionStorage.setItem('PREVIOUS_PAGE', window.location.href)
                            }}
                        >{menuOptions.tituloContactanos}</a></li>

                        {((process.env.LOCALE === "es-DO") || (process.env.LOCALE === "es-BO")) &&
                            <li><a className="f-m-footer__content-item-redirection"
                                onClick={() => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackEvent',
                                        'eventCategory': 'ui :: footer :: ' + screen,
                                        'eventAction': 'click',
                                        'eventLabel': "whatsapp"
                                    });

                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackGA4',
                                        'event_type': 'user_interaction',
                                        'section': 'footer',
                                        'action': 'click',
                                        'element': "whatsapp",
                                        'screen_name': screen
                                    });
                                }}
                                href={menuOptions.redireccionWhatsapp}
                            >{menuOptions.whatsapp}</a></li>
                        }
                        <li><a className="f-m-footer__content-item-redirection"
                            onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'trackEvent',
                                    'eventCategory': 'ui :: footer :: ' + screen,
                                    'eventAction': 'click',
                                    'eventLabel': "faq"
                                });

                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'trackGA4',
                                    'event_type': 'user_interaction',
                                    'section': 'footer',
                                    'action': 'click',
                                    'element': "faq",
                                    'screen_name': screen
                                });
                            }}
                            href={homeLink + menuOptions.redireccionPreguntasFrecuentes}
                        >{menuOptions.tituloPreguntasFrecuentes}</a></li>
                    </ul>
                </div>
                <div className="f-m-footer__content-item">
                    <h3>{menuOptions.tituloRedesSociales}</h3>
                    <ul>
                        {
                            menuOptions.redesSociales.map((red, index) => {
                                return (
                                    <li key={index}>
                                        <div className="f-m-footer__content-item-redirection"
                                            onClick={() => {
                                                window.dataLayer = window.dataLayer || [];
                                                window.dataLayer.push({
                                                    'event': 'trackEvent',
                                                    'eventCategory': 'ui :: footer :: ' + screen,
                                                    'eventAction': 'click',
                                                    'eventLabel': 'seguir :: ' + red.nombreDeLaCategoria
                                                });

                                                window.dataLayer = window.dataLayer || [];
                                                window.dataLayer.push({
                                                    'event': 'trackGA4',
                                                    'event_type': 'user_interaction',
                                                    'section': 'footer',
                                                    'action': 'click',
                                                    'element': 'seguir :: ' + red.nombreDeLaCategoria,
                                                    'screen_name': screen
                                                });

                                                window.open(red.redireccionDeLaCategoria, "_blank")
                                            }}
                                        >
                                            <GatsbyImage
                                                className="f-m-footer__content-item-imagen"
                                                image={red.imagenCategorias[0].gatsbyImageData}
                                                alt={red.imagenCategorias[0].description}
                                            />
                                            {red.nombreDeLaCategoria}
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
            <div className="f-m-footer__separator"></div>
            <div className="f-m-footer__country">
                <p className="f-m-footer__country-text">ESTÁS EN EL SITIO DE:</p>
                <GatsbyImage className="f-m-footer__country-flag" image={menuOptions.paises[0].banderaPais.gatsbyImageData} alt={menuOptions.paises[0].banderaPais.description} />
                <p className="f-m-footer__country-text f-m-footer__country-text-country" onClick={mobile ? openModal : () => { }}>{menuOptions.paises[0].pais}</p>
                <div className="f-m-footer__country-change" onClick={openModal}>
                    <p>Cambiar país</p>
                </div>
            </div>
            {modalChange && <ModalChangeCountry countries={resultQuery.allContentfulPequeninFooter.nodes} setModalChange={setModalChange} />}
        </footer>
    )
}

export default Footer
